export const routeOutConfirmationMixin = {
  data() {
    return {
      allowRouteExitWithoutConfirmation: true
    };
  },
  beforeRouteLeave(to, from, next) {
    const skipConfirmation = this.allowRouteExitWithoutConfirmation || (to.params.allowRouteExitWithoutConfirmation);
    if (!skipConfirmation) {
      const answer = window.confirm(this.$t('routeOutConfirmation'));
      if (answer) {
        next();
      } else next(false);
    } else next();
  },
};

export const productTextFilter = (product, queryText) => {
  const searchText = queryText.toLowerCase();
  const name = product.name.toLowerCase();
  const commercialNameAlt1 = product.commercial_name_alt1 ? product.commercial_name_alt1.toLowerCase() : '';
  const commercialNameAlt2 = product.commercial_name_alt2 ? product.commercial_name_alt2.toLowerCase() : '';
  const commercialNameAlt3 = product.commercial_name_alt3 ? product.commercial_name_alt3.toLowerCase() : '';
  return name.indexOf(searchText) > -1
      || commercialNameAlt1.indexOf(searchText) > -1
      || commercialNameAlt2.indexOf(searchText) > -1
      || commercialNameAlt3.indexOf(searchText) > -1;
};
